import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUp, Home, Shield, Lock, Eye, UserCheck, Mail } from 'lucide-react';

const PolitiqueConfidentialite = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Politique de Confidentialité - Frelon33™ | Protection des Données RGPD";
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-white to-purple-50/30">
      {/* Hero Section RGPD */}
      <section className="bg-gradient-to-r from-purple-600 to-blue-500 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center frelon-slide-up">
            <h1 className="text-4xl md:text-5xl font-black mb-4">
              Politique de Confidentialité
            </h1>
            <p className="text-xl font-medium opacity-90">
              Protection de vos données personnelles - <span className="frelon33-brand">Frelon33™</span>
            </p>
            <div className="mt-8">
              <Link
                to="/"
                className="frelon-btn frelon-btn-secondary inline-flex items-center space-x-2 px-6 py-3 bg-white text-purple-600 hover:bg-purple-50"
              >
                <Home className="h-5 w-5" />
                <span>Retour à l'accueil</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contenu RGPD */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="frelon-card border-0 frelon-depth-2">
            <div className="prose prose-lg max-w-none">
              
              <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 rounded-2xl mb-8 border border-purple-100">
                <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                  <Shield className="h-6 w-6 text-purple-600 mr-2" />
                  Engagement RGPD
                </h2>
                <p className="text-gray-700">
                  <strong className="frelon33-brand">Frelon33™</strong> s'engage à protéger votre vie privée 
                  et à traiter vos données personnelles en conformité avec le Règlement Général sur la 
                  Protection des Données (RGPD).
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                1. Responsable du traitement
              </h2>
              
              <div className="frelon-card bg-green-50 border-green-200 mb-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Identité du responsable</h3>
                    <p className="text-gray-700">
                      <strong>Nom :</strong> Jessy Josselin Jordan Duchemin<br />
                      <strong>Entreprise :</strong> Frelon33™<br />
                      <strong>SIRET :</strong> 92880712200017
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                      <Mail className="h-5 w-5 text-green-600 mr-2" />
                      Contact RGPD
                    </h3>
                    <p className="text-gray-700">
                      <strong>E-mail :</strong> frelon33000@gmail.com<br />
                      <strong>Téléphone :</strong> 06 76 58 30 38
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                2. Données collectées
              </h2>
              
              <div className="space-y-6 mb-8">
                <div className="frelon-card bg-blue-50 border-blue-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <UserCheck className="h-5 w-5 text-blue-600 mr-2" />
                    Données d'identification
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700">
                    <li>Nom et prénom</li>
                    <li>Adresse e-mail</li>
                    <li>Numéro de téléphone</li>
                    <li>Adresse de l'intervention</li>
                  </ul>
                </div>

                <div className="frelon-card bg-yellow-50 border-yellow-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    Données techniques (automatiques)
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700">
                    <li>Adresse IP</li>
                    <li>Type de navigateur</li>
                    <li>Pages visitées</li>
                    <li>Horodatage des visites</li>
                  </ul>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                3. Finalités du traitement
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="frelon-card bg-green-50 border-green-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    Finalités principales
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Répondre à vos demandes de contact</li>
                    <li>Établir des devis d'intervention</li>
                    <li>Planifier les interventions</li>
                    <li>Assurer le suivi client</li>
                  </ul>
                </div>
                
                <div className="frelon-card bg-purple-50 border-purple-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    Finalités techniques
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Améliorer le fonctionnement du site</li>
                    <li>Assurer la sécurité des données</li>
                    <li>Respecter nos obligations légales</li>
                    <li>Analyser l'audience du site</li>
                  </ul>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                4. Base légale du traitement
              </h2>
              
              <div className="space-y-4 text-gray-700 leading-relaxed mb-8">
                <p>
                  Le traitement de vos données personnelles est fondé sur :
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Votre consentement</strong> lors de l'utilisation du formulaire de contact</li>
                  <li><strong>L'exécution du contrat</strong> pour la réalisation des interventions</li>
                  <li><strong>Notre intérêt légitime</strong> pour l'amélioration de nos services</li>
                  <li><strong>Le respect d'obligations légales</strong> (facturation, comptabilité)</li>
                </ul>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                5. Durée de conservation
              </h2>
              
              <div className="frelon-card bg-orange-50 border-orange-200 mb-8">
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  Durées de conservation des données
                </h3>
                <div className="space-y-2 text-gray-700">
                  <p><strong>Demandes de contact :</strong> 3 ans à compter du dernier contact</p>
                  <p><strong>Données clients :</strong> 5 ans après la dernière intervention</p>
                  <p><strong>Données comptables :</strong> 10 ans (obligation légale)</p>
                  <p><strong>Logs techniques :</strong> 12 mois maximum</p>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                6. Destinataires des données
              </h2>
              
              <div className="space-y-4 text-gray-700 leading-relaxed mb-8">
                <p>
                  Vos données personnelles sont destinées exclusivement à :
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Frelon33™</strong> et son personnel autorisé</li>
                  <li><strong>Nos prestataires techniques</strong> : Netlify (hébergement), FormSubmit (acheminement du formulaire de contact vers notre email), Google (Tag Manager, Google Ads – mesure d'audience et publicité)</li>
                  <li><strong>Les autorités</strong> si requis par la loi</li>
                </ul>
                <div className="frelon-card bg-red-50 border-red-200 mt-6">
                  <p className="text-red-800 font-semibold">
                    ❌ Aucune donnée n'est vendue, louée ou cédée à des tiers à des fins commerciales.
                  </p>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                7. Vos droits RGPD
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="frelon-card bg-blue-50 border-blue-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <Eye className="h-5 w-5 text-blue-600 mr-2" />
                    Droits d'accès et de portabilité
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700">
                    <li>Droit d'accès à vos données</li>
                    <li>Droit à la portabilité</li>
                    <li>Droit de rectification</li>
                  </ul>
                </div>
                
                <div className="frelon-card bg-red-50 border-red-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <Lock className="h-5 w-5 text-red-600 mr-2" />
                    Droits de suppression et d'opposition
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700">
                    <li>Droit à l'effacement</li>
                    <li>Droit d'opposition</li>
                    <li>Droit à la limitation</li>
                  </ul>
                </div>
              </div>

              <div className="frelon-card bg-green-50 border-green-200 mb-8">
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  Comment exercer vos droits ?
                </h3>
                <p className="text-gray-700 mb-3">
                  Pour exercer vos droits, contactez-nous :
                </p>
                <ul className="list-none space-y-2 text-gray-700">
                  <li><strong>E-mail :</strong> frelon33000@gmail.com</li>
                  <li><strong>Téléphone :</strong> 06 76 58 30 38</li>
                  <li><strong>Délai de réponse :</strong> 1 mois maximum</li>
                </ul>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                8. Sécurité des données
              </h2>
              
              <div className="space-y-4 text-gray-700 leading-relaxed mb-8">
                <p>
                  <strong className="frelon33-brand">Frelon33™</strong> met en œuvre toutes les mesures 
                  techniques et organisationnelles appropriées pour protéger vos données personnelles :
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Chiffrement des données lors de la transmission (HTTPS)</li>
                  <li>Hébergement sécurisé (Netlify)</li>
                  <li>Accès restreint aux données personnelles</li>
                  <li>Surveillance et journalisation des accès</li>
                </ul>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                9. Cookies et traceurs
              </h2>

              <div className="frelon-card bg-yellow-50 border-yellow-200 mb-8">
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  🍪 Cookies utilisés
                </h3>
                <p className="text-gray-700 mb-3">
                  Ce site utilise, <strong>sous réserve de votre consentement</strong>, des cookies et
                  technologies de mesure et de publicité fournis par Google :
                </p>
                <ul className="list-disc list-inside space-y-1 text-gray-700 mb-3">
                  <li><strong>Google Tag Manager</strong> (gestion des balises)</li>
                  <li><strong>Google Ads</strong> (mesure des conversions de nos campagnes publicitaires)</li>
                  <li>Cookies de mesure d'audience associés</li>
                </ul>
                <p className="text-gray-700">
                  Les cookies techniques strictement nécessaires au fonctionnement du site sont toujours actifs.
                  Les cookies de mesure et de publicité ne sont déposés qu'après votre accord via le bandeau
                  de consentement (Google Consent Mode). Vous pouvez refuser ou modifier votre choix à tout moment
                  en revenant sur le site (via la suppression du choix mémorisé dans votre navigateur).
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                10. Transferts de données
              </h2>
              
              <div className="space-y-4 text-gray-700 leading-relaxed mb-8">
                <p>
                  Vos données personnelles sont traitées et stockées exclusivement au sein de l'Union Européenne. 
                  Aucun transfert vers des pays tiers n'est effectué.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                11. Réclamation
              </h2>
              
              <div className="frelon-card bg-purple-50 border-purple-200 mb-8">
                <p className="text-gray-700">
                  En cas de réclamation concernant le traitement de vos données personnelles, 
                  vous pouvez saisir la <strong>Commission Nationale de l'Informatique et des Libertés (CNIL)</strong> :
                </p>
                <p className="text-gray-700 mt-2">
                  <strong>Site web :</strong> <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700">www.cnil.fr</a>
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-6 frelon-heading">
                12. Modifications de la politique
              </h2>
              
              <div className="space-y-4 text-gray-700 leading-relaxed mb-8">
                <p>
                  Cette politique de confidentialité peut être modifiée à tout moment. 
                  Les modifications prennent effet dès leur publication sur le site.
                </p>
                <p>
                  Nous vous invitons à consulter régulièrement cette page pour rester informé 
                  de nos pratiques en matière de protection des données.
                </p>
              </div>

              <div className="mt-12 text-center">
                <p className="text-sm text-gray-500 mb-4">
                  Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
                </p>
                <button
                  onClick={scrollToTop}
                  className="frelon-btn frelon-btn-primary inline-flex items-center space-x-2 px-6 py-3"
                >
                  <ArrowUp className="h-5 w-5" />
                  <span>Retour en haut</span>
                </button>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PolitiqueConfidentialite;